import {useState} from "@wordpress/element";
import {Button, ConfigProvider, Drawer, Form, Input, Space} from "antd";

export default function SearchBlock() {
  const [open, setOpen] = useState<boolean>(false)
  const onSearchBtnClick = () => {
    setOpen(true)
  }

  const onSearch = (values: Record<string, any>) => {
    window.location.href = '/?s=' + values.searchText
  }

  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: '#166987',
          colorLink: '#166987'
        }
      }}
    >
      <div className={'cursor-pointer px-2'} onClick={onSearchBtnClick}>
        <svg xmlns="http://www.w3.org/2000/svg" height={20} width={20} fill="currentColor" version="1.1" viewBox="0 0 53.627 53.627">
          <path d="M53.627,49.385L37.795,33.553C40.423,30.046,42,25.709,42,21C42,9.42,32.58,0,21,0S0,9.42,0,21s9.42,21,21,21  c4.709,0,9.046-1.577,12.553-4.205l15.832,15.832L53.627,49.385z M2,21C2,10.523,10.523,2,21,2s19,8.523,19,19s-8.523,19-19,19  S2,31.477,2,21z"/>
        </svg>
      </div>
      <Drawer open={open} title={null} width={'100%'} closeIcon={null} footer={null} styles={{
        body: { padding: 0 }
      }}>
        <div className={'h-full bg-lightblue relative'}>
          <div className={'absolute top-1/2 w-full p-8 -translate-y-1/2'}>
            <div className={'text-white mb-8 font-bold text-2xl'}>Tìm kiếm</div>
            <Form onFinish={onSearch}>
              <Form.Item name={'searchText'} rules={[
                { required: true, message: 'Từ khoá không hợp lệ'}
              ]}>
                <Input
                  size={'large'}
                  placeholder={'Nhập nội dung tìm kiếm'}
                />
              </Form.Item>
              <Space>
                <Button onClick={() => setOpen(false)}>Huỷ</Button>
                <Button htmlType={'submit'} type={'primary'}>Tìm kiếm</Button>
              </Space>
            </Form>
          </div>
        </div>
      </Drawer>
    </ConfigProvider>
  )
}